var houseland = {
    init: function() {
        houseland.setNewOptions();
        houseland.toggle_radio();

        if ($('.collapse').length){
            $('.collapse').collapse('hide');
        }

        //var myLink = $('a.noSS').attr('href', $('a.noSS').attr('href').split('#')[1]);
        $('.btn.sold').attr('href','').removeAttr('data-toggle').css('cursor','default').on('click', function(e){
            e.preventDefault();
        });

        $('.results-header:eq(0)').css('margin-top','0');

        $('.mini-map-768, .mini-map-992').each(function(){
            $(this).prepend('<a class="mapmini mapovis" href="#"></a>');
        });

        $('aside #form-1').attr('action','land-for-sale');
        $('aside #form-2').attr('action','house-and-land-packages');


    },

    setNewOptions: function () {
        //TODO: tidy this function up...
        var newFromOptions = {
            "350000": "$350k",
            "375000": "$375k",
            "400000": "$400k",
            "425000": "$425k"
        };
        var $el = $("select[name='land_price_from']");
        $el.empty(); // remove old options
        $el.prepend($("<option></option>").attr("value", "").text("From Any"));
        $.each(newFromOptions, function(value,key) {
            $el.append($("<option></option>").attr("value", value).text(key));
        });

        var newToOptions = {
            "375000": "$375k",
            "400000": "$400k",
            "425000": "$425k",
            "450000": "$450k"
        };
        var $el = $("select[name='land_price_to']");
        $el.empty(); // remove old options
        $el.prepend($("<option></option>").attr("value", "").text("To Any"));
        $.each(newToOptions, function(value,key) {
            $el.append($("<option></option>").attr("value", value).text(key));
        });

    },

    toggle_radio: function() {
        // toggle forms and classes
        $(".radio-tabs label").each(function(i){
            if ($('.land-listings').length) {
                $('aside .forms-widget form:eq(0)').show();
            }
            else {
                $('aside .forms-widget form:eq(1)').show();
            }

            if ($('.page-land-for-sale').length) {
                $('.radio-tabs label:eq(0)').addClass('active').find('.radio').addClass('checked').removeClass('unchecked');
                $('.radio-tabs label:eq(1)').removeClass('active').find('.radio').removeClass('checked').addClass('unchecked');
            }
            else {
                if ($('.page-house-and-land-packages').length) {
                    $('.radio-tabs label:eq(0)').removeClass('active').find('.radio').removeClass('checked').addClass('unchecked');
                    $('.radio-tabs label:eq(1)').addClass('active').find('.radio').addClass('checked').removeClass('unchecked');
                }
            }


            $(this).on('click', function(){
                $(".radio-tabs label").each(function(){
                    $(this).removeClass('active');
                    $(this).find('.radio').removeClass('checked').addClass('unchecked');
                });

                $(this).addClass('active');
                $(this).find('.radio').addClass('checked').removeClass('unchecked');

                $('aside .forms-widget form').each(function(){
                    $(this).parent().find('.form').hide();
                    $(this).parent().find('.form:eq('+i+')').show();
                });

            });
        });
    }
};


$(document).ready(function() {
    houseland.init();
});